import { connect } from "react-redux";
import PercentageDisplay from "../../../../components/percentageDisplay/percentageDisplay";
import { formatChurnRate } from "../../../../utils/formatChurnRate";

export default connect(state => {
  const { churnRate = {} } = state.membershipUnits.membershipUnits || {};
  const value = formatChurnRate(churnRate.value || churnRate.churnRate);

  return {
    value,
    currency: "%",
    showDecimal: true,
    toFixedValue: value > 0 ? 2 : undefined,
    disableAnimation: state.membershipUnits.currentUser.qa,
    toolTipContent: churnRate.tooltip,
    toolTipId: "membershipUnitToolTip"
  };
})(PercentageDisplay);
